import * as React from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';

type LabelType = 'input' | 'clickbox' | 'textarea' | 'plaintext';

interface ILabelAboveProps {
	type: LabelType;
	textIsHtml?: boolean;
	text?: string;
}

const ClickboxStyle = `
	margin-bottom: 20px;
`;
const InputStyle = `
	margin-bottom: 15px;
`;
const PlainTextStyle = `
	margin-bottom: 15px;
`;
const TextAreaStyle = `
	margin-bottom: 30px;
`;
const StyledLabel = styled.label<{ type?: LabelType }>`
	display: block;
	color: #696969;
	${(props) => (props.type === 'input' ? InputStyle : '')}
	${(props) => (props.type === 'plaintext' ? PlainTextStyle : '')}
	${(props) => (props.type === 'clickbox' ? ClickboxStyle : '')}
	${(props) => (props.type === 'textarea' ? TextAreaStyle : '')}
`;

export class LabelAbove extends React.Component<React.PropsWithChildren<ILabelAboveProps>> {
	public render() {
		const { children, textIsHtml, text, type } = this.props;
		if (textIsHtml === true && text) {
			return <StyledLabel type={type}>{HtmlParser(text)}</StyledLabel>;
		}
		return <StyledLabel type={type}>{text || children}</StyledLabel>;
	}
}
